import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { CreateBlueSheetDrawer } from '../../../../../../../../../../features/trade-reporting/blue-sheet/create-bluesheet-drawer';
import { TradeReportingBlueSheetsTable } from '../../../../../../../../../../features/trade-reporting/blue-sheet/trade-reporting-blue-sheets-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceReporting,
      label: 'Blue Sheets',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceReporting>,
  head: () => getPageHead('Blue Sheet Reports'),
  component: BlueSheetList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateBlueSheetDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Blue Sheet Report" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingComplianceReporting}
    />
  );
}

function BlueSheetList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TradeReportingBlueSheetsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
